<!-- `navbar-expand` (no breakpoint): the bar keeps its desktop layout at every
     viewport width. There is no collapsed/mobile variant any more. -->
<nav class="navbar navbar-expand fixed-top bg-dark" [ngClass]="getNavClass()">
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <ul class="navbar-nav ml-1">
        <li class="nav-item text-nowrap" ngbDropdown>
          <a class="nav-link nav-environment" ngbDropdownToggle id="user-menu">
            <img
              src="{{ 'BO_LOGO_URL[' + getApplicationId() + ']' | translate }}"
              />
              <span><br />{{ getClient() }}</span>
            </a>
            <div
              class="dropdown-menu dropdown-menu-left nav-environment-list"
              ngbDropdownMenu
              aria-labelledby="user-menu"
              >
              @for (app of applications; track app) {
                <a
                  class="dropdown-item  {{ getClassItem(app.route) }}"
                  (click)="changeApplication(app.route)"
                  >{{ app.text }}</a
                  >
              }
            </div>
          </li>
        </ul>
      </div>
      <div class="navbar-collapse justify-content-end bg-dark">
        <ul class="navbar-nav">
          @for (dropParams of menus; track dropParams) {
            <app-navbar-drop
              [props]="dropParams"
            ></app-navbar-drop>
          }
        </ul>

        <form
          [formGroup]="searchForm"
          (submit)="searchSubmit()"
          class="search-form"
          >
          <div class="search-input-group input-group no-border text-nowrap">
            <input
              type="search"
              value=""
              class="form-control"
              [placeholder]="'BO_SEARCH' | translate"
              [formControlName]="'search'"
              #search
              title="search"
              />
              <div class="input-group-append">
                <button type="submit" class="input-group-text">
                  <i class="now-ui-icons ui-1_zoom-bold"></i>
                </button>
              </div>
            </div>
          </form>
          <ul class="navbar-nav ml-3 mr-2">
            <li class="nav-item" [class.active]="isSidebarOpen$ | async">
              <a class="nav-link" (click)="toggleSidebar()">
                <i class="now-ui-icons business_bulb-63"></i>
              </a>
            </li>
            <li class="nav-item" [class.active]="isBookmarksOpen$ | async">
              <a class="nav-link" (click)="toggleBookmarks()">
                <i class="now-ui-icons education_agenda-bookmark"></i>
              </a>
            </li>
            <app-notification-bell class="nav-item" [newCommandsCount]="newComandsCount"></app-notification-bell>
            <li class="nav-item text-nowrap" ngbDropdown>
              <a class="nav-link" ngbDropdownToggle id="user-menu">
                <i class="now-ui-icons users_single-02"></i>
              </a>
              <div
                style="min-width: 230px"
                class="dropdown-menu dropdown-menu-right"
                ngbDropdownMenu
                aria-labelledby="user-menu"
                >
                <div
                  class="px-4 py-3 text-uppercase"
                  style="vertical-align: top; color: #777"
                  >
                  <i
                    style="position: relative; top: 3px"
                    class="now-ui-icons users_single-02"
                  ></i>
                  <span
                    ><b>{{ getUser() }}</b></span
                    >
                  </div>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" routerLink="/changepassword">{{
                    'BO_CHANGE_PASSWORD' | translate
                  }}</a>
                  <a class="dropdown-item" routerLink="/mfa">{{
                    'BO_MFA_SETUP' | translate
                  }}</a>
                  <a class="dropdown-item" routerLink="admin/settings">{{
                    'BO_SETTINGS' | translate
                  }}</a>
                  <a class="dropdown-item" href="#" (click)="toggleTheme($event)">{{
                    (isLightTheme$ | async) ? 'Dark theme' : 'Light theme'
                  }}</a>
                  <a class="dropdown-item" href="#" (click)="logout($event)">{{
                    'BO_LOGOUT' | translate
                  }}</a>
                </div>
              </li>
              <li class="nav-item d-flex align-items-center">
                @if (langSet.length > 1) {
                  <app-lang-switcher></app-lang-switcher>
                }
              </li>
            </ul>
          </div>
        </div>

        <!--<div class="alert alert-warning alert-dismissible timoutnotification" *ngIf="timedOut()">Your session has timed out</div>-->
      </nav>
